<template>
  <v-container>
    <v-autocomplete
      v-model="teamLookup.selected"
      :items="teamLookup.data"
      :loading="teamLookup.loading"
      item-value="id"
      label="Teams"
      hide-no-data
      clearable
      item-title="name"
      :search-input="search"
      @update:search="search"
      @update:model-value="onTeamSelected"
      @click:clear="clearSelections">
    </v-autocomplete>
    <div v-if="teamCriteriaData && teamCriteriaData.data.length > 0">
      <v-alert type="info" class="mt-2">
        Number(s):
        {{
          teamCriteriaData.data
            .map((x) => x.criteria?.number)
            .filter((x): x is number => x != null)
            .sort((a, b) => a - b)
            .join(', ')
        }}
        have already been selected for this team.
      </v-alert>
    </div>
    <CriteriaTimeLimitCompontent
      v-if="teamLookup.selected"
      :year-id="yearId"
      :team-id="teamLookup.selected"
      @snack="throwSnack"
      @close="clearSelections"></CriteriaTimeLimitCompontent>
    <CriteriaSelectionCompontent
      :year-id="yearId"
      :branch-year="branchYear"
      :team-id="teamLookup.selected"
      @snack="throwSnack"
      @clear-selection="clearSelections"></CriteriaSelectionCompontent>
  </v-container>
</template>

<script setup lang="ts">
import CriteriaSelectionCompontent from '@/components/criteria/CriteriaSelectionCompontent.vue';
import CriteriaTimeLimitCompontent from '@/components/criteria/CriteriaTimeLimitCompontent.vue';
import { BranchYearDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useCriteriaStore } from '@/stores/modules';
import { useBranchYearStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { ref, computed } from 'vue';

//import { sendMessageToDiscord } from '@/controllers/admin/discordController';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  branchId: string;
  yearId: string;
  branchYear: BranchYearDTO;
}
const props = defineProps<Props>();
const branchYearStore = useBranchYearStore();
const criteriaStore = useCriteriaStore();
const branchId = computed(() => props.branchId);
const yearId = computed(() => props.yearId);
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const { data: branchYearData, isLoading: branchyearIsLoading } =
  branchYearStore.getBranchYearTeamsQuery(branchId, yearId, pagination);
const teamLookup = ref({
  selected: '',
  data: computed(() => branchYearData.value?.data ?? []),
  loading: computed(() => branchyearIsLoading.value),
});
const selectedTeam = ref<string>('');
const clearSelections = () => {
  teamLookup.value.selected = '';
  selectedTeam.value = '';
};

const onTeamSelected = (value: string) => {
  selectedTeam.value = value;
};

const search = async (value: string) => {
  pagination.value.q = value;
};

const { data: teamCriteriaData } = criteriaStore.getTeamsCriteriaQuery(yearId, selectedTeam);
</script>
